import { useState } from "react";
import { toast } from "sonner";
import { Copy, Check, Globe, Link2, Code2 } from "lucide-react";
import Navbar from "@/components/Navbar";

function Snippet({ title, desc, code, testid }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    await navigator.clipboard.writeText(code);
    setCopied(true); toast.success("Kode disalin");
    setTimeout(() => setCopied(false), 1500);
  };
  return (
    <div className="bg-white rounded-xl border border-[#E5DFD7] shadow-sm p-6" data-testid={testid}>
      <div className="flex items-start justify-between gap-4 mb-3">
        <div>
          <h2 className="font-display text-lg font-semibold text-[#1F1917]">{title}</h2>
          <p className="text-sm text-[#8C827A] mt-0.5">{desc}</p>
        </div>
        <button onClick={copy} className="inline-flex items-center gap-1.5 bg-[#4A2E2B] text-white px-3.5 py-2 rounded-lg text-sm font-bold hover:bg-[#3a2320] transition shrink-0">
          {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />} Salin
        </button>
      </div>
      <pre className="bg-[#1F1917] text-[#F7F4EF] text-xs rounded-lg p-4 overflow-x-auto whitespace-pre-wrap break-all">{code}</pre>
    </div>
  );
}

export default function IntegrationPage() {
  const origin = window.location.origin;
  const btn = `<a href="${origin}" target="_blank" rel="noopener" style="display:inline-flex;align-items:center;gap:8px;background:#4A2E2B;color:#fff;padding:12px 20px;border-radius:999px;font-weight:700;text-decoration:none;font-family:sans-serif">
  <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:#E5A93C"></span>
  Pusat Data Pramuka Kota Depok (SIPRAM)
</a>`;
  const iframe = `<iframe src="${origin}/embed/statistik" width="360" height="230" style="border:0;border-radius:16px;overflow:hidden" loading="lazy" title="SIPRAM Depok"></iframe>`;
  const menu = `${origin}`;

  return (
    <div className="min-h-screen">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 space-y-6">
        <div>
          <h1 className="font-display text-3xl font-extrabold text-[#1F1917] flex items-center gap-2"><Globe className="h-7 w-7 text-[#B85C38]" /> Integrasi Situs Resmi</h1>
          <p className="text-[#8C827A] mt-1">
            Salin kode berikut dan tempel di <a href="https://pramukakotadepok.or.id/" target="_blank" rel="noreferrer" className="font-semibold text-[#B85C38] hover:underline">pramukakotadepok.or.id</a> (WordPress: Tampilan → Widget / Menu, atau blok "HTML Kustom") agar pengunjung dapat mengklik menuju SIPRAM.
          </p>
        </div>
        <Snippet testid="integration-menu-link" title="1. Tautan Menu" desc="Tambahkan sebagai item menu navigasi 'Pusat Data' di situs resmi (Tampilan → Menu → Tautan Khusus)." code={menu} />
        <Snippet testid="integration-button" title="2. Tombol Siap Pakai" desc="Tempel di halaman/sidebar sebagai blok HTML Kustom." code={btn} />
        <Snippet testid="integration-iframe" title="3. Widget Statistik (iframe)" desc="Menampilkan jumlah kwarran, peserta didik, dan pembina secara real-time; klik widget membuka SIPRAM." code={iframe} />
        <div className="bg-[#F7F4EF] border border-[#E5DFD7] rounded-xl p-5 text-sm text-[#4A423F] flex gap-3">
          <Link2 className="h-5 w-5 text-[#B85C38] shrink-0" />
          <div>
            Sebaliknya, SIPRAM sudah menautkan ke situs resmi di header dan footer halaman depan. Setelah aplikasi dipublikasikan (deploy) ke alamat tetap/domain sendiri, buka kembali halaman ini agar kode di atas otomatis memakai alamat baru.
          </div>
        </div>
        <div className="text-xs text-[#8C827A] flex items-center gap-1.5"><Code2 className="h-3.5 w-3.5" /> Pratinjau widget: <a href="/embed/statistik" target="_blank" className="text-[#B85C38] hover:underline">{origin}/embed/statistik</a></div>
      </div>
    </div>
  );
}
